import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Typography, TextField, CircularProgress } from '@mui/material'
import SelectCompany, { CompanyType } from 'proposals/components/SelectCompany'

type PublicRequestForProposalParticipateProps = {
  email: string
  company: CompanyType | null
  setCompany: (company: CompanyType | null) => void
  onEmailChange: (email: string) => void
  onSubmit: () => void
  emailError: string
  onEmailBlur: () => void
  isLoading?: boolean
}

const PublicRequestForProposalParticipate: React.FC<PublicRequestForProposalParticipateProps> = ({ 
  email, company, setCompany, onEmailChange, onSubmit, emailError, onEmailBlur, isLoading = false 
}) => {
  const { t } = useTranslation()

  const handleEmailInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onEmailChange(e.target.value)
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        {t('participate-tendering')}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t('participate-tendering-info')}
      </Typography>
      
      <SelectCompany selectCompany={setCompany} selectedValue={company} region={''} label={t('company')} />
      
      <TextField
        fullWidth
        variant="filled"
        label={t('email')}
        type="email"
        value={email}
        onChange={handleEmailInputChange}
        onBlur={onEmailBlur}
        error={!!emailError}
        helperText={emailError}
        required
        sx={{ mt: 2, mb: 3 }}
      />
      
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="outlined" 
          color="grey"
          disabled={!company || !email || !!emailError || isLoading}
          onClick={onSubmit}
        >
          {isLoading ? <CircularProgress size={16} /> : t('participate')}
        </Button>
      </Box>
    </Box>
  )
}

export default PublicRequestForProposalParticipate